module.exports = __webpack_public_path__ + "img/file-07.83c71220.svg";